<template>
<div class=''>
    <Col span="24" class="videoBox">
        <Col span="5" v-for="(item,index) in videoList" :key="index" class="items">
          <img :src="item.videoImg" alt="" @click="goVideo(item.id)">
          <div class="textBox">
            <p class="videoTitle" @click="goVideo(item.id)">{{item.videoName}}</p>
            <p class="time">
              {{item.createTime}}
              <Icon type="md-star" class="collect_icon" @click="uncollect(item.id)"/>
            </p>
          </div>
        </Col>
      </Col>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  videoList:[]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//生命周期 - 创建完成（可以访问当前this实例）
activated() {
  this.getVideo()
},
//方法集合
methods: {
 getVideo(){
   this.$axios
        .get("/safe-train/videoCollection/pageForCollect?size=1000")
        .then((res) => {
          if (res.code == 1) {
            this.videoList = res.data.records;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
 //取消收藏
  uncollect(id){
      this.$axios
        .get("/safe-train/videoCollection/collect?id="+id)
        .then((res) => {
          if (res.code == 1) {
            this.$Message.success('取消收藏成功')
            this.getVideo()
          } else {
            this.$Message.error(res.msg);
          }
    });
 },
  //跳转视频页面
 goVideo(id){
   console.log(id,'id')
   this.$router.push({name:'VideoPage',query:{id:id}})
 },
  },
}
</script>
<style lang='less' scoped>
  .videoBox{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: space-between;
    // padding-left: 20px;
      img{
        width: 100%;
        height: 12vw;
      }
      video{
        width: 100%;
      }

      .items{
        width: 15vw;
        height: 20vw;
        position: relative;
        padding:.4vw;
        box-shadow: 10px 10px 20px #999;
        border-radius: .5vw;
        margin: .5vw;

        .textBox{
          height: 7vw;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        
        .videoTitle{
          width: 100%;
          color: #333;
          font-size: .8vw;
          padding:0 .4vw;
          position: relative;
          overflow:hidden; 
          text-overflow:ellipsis;
          display:-webkit-box; 
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2; 
        }

        .time{
          text-align: right;
          color: #999;
        }

        .collect_icon{
          font-size:1.5vw;
          color: #FFCC00;
        }
      }
  }
</style>